import { render } from "./folder.vue?vue&type=template&id=4e5ebf8e&scoped=true"
import script from "./folder.vue?vue&type=script&lang=ts"
export * from "./folder.vue?vue&type=script&lang=ts"

import "./folder.vue?vue&type=style&index=0&id=4e5ebf8e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4e5ebf8e"

export default script